export default {
    baseGroups:            { method: 'get',    url: 'base_groups' },
    createBaseGroup:       { method: 'post',   url: 'base_groups'},
    updateBaseGroup:       { method: 'put',    url: 'base_groups/{id}'},
    deleteBaseGroup:       { method: 'delete', url: 'base_groups/{id}'},
    baseGroupStatus:        { method: 'get',    url: 'base_groups/status' },
}